<div class="container">
    <div class="row d-flex justify-content-center">
        <div class="col-md-12 text-center main-title">
            <h1>Indicazioni operative</h1>
        </div>
    </div>

    <div class="datatable mt-4">
        <h3>Elenco indicazioni operative</h3>
        <div class="row d-flex justify-content-end" *ngIf="isLocalhost">
            <div class="col-md-3">
                <button type="button" class="btn btn-primary" (click)="caricaDati()">
                    Ricarica dati
                </button>
            </div>
            <div class="col-md-3">
                
            </div>
            <div class="col-md-3">
                <select id="comboDate" class="form-control" [formControl]="comboDate" 
                (change)="cambiaData()">
                    <option *ngFor="let date of dates" [value]="date">{{date}}</option>
                </select>
                <label for="comboDate" class="form-label">Seleziona Data</label>
            </div>
            <div class="col-md-3">
                <button type="button" class="btn btn-primary" (click)="updateData()">
                    Aggiorna dati
                </button>
            </div>
                    <div *ngIf="updating" class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
        </div>
        <table class="table datatable-table" mdbTable mdbTableSort #table="mdbTable" #sort="mdbTableSort"
            [dataSource]="tableData" [sort]="sort">
            <thead class="datatable-header">
                <tr>
                    <th *ngFor="let header of headers" [mdbTableSortHeader]="header" scope="col">
                        {{ header | titlecase }}
                    </th>
                </tr>
            </thead>
            <tbody class="datatable-body">
                <tr *ngIf="loadingData">
                    <td colspan="9">
                        <div class="d-flex align-items-center text-center">
                            <strong>Loading...</strong>
                            <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                        </div>
                    </td>
                </tr>
                <tr *ngFor="let data of table.data" scope="row">
                    <td>{{data.id}}</td>
                    <td>{{data.giorno}}</td>
                    <td>{{data.market}}</td>
                    <td>{{data.verso}}</td>
                    <td>{{data.vopen}}</td>
                    <td [ngClass]="data.enter==0 ? '' : data.entrata ? 'green' : 'silver'">{{data.enter | number : '1.4-4'}}</td>
                    <td>{{(data.verso=='BUY' ? data.stoploss*0.8 : data.stoploss*0.4) | number : '1.4-4'}}</td>
                    <td>{{data.stoploss | number : '1.4-4'}}</td>
                    <td>{{data.swing}}</td>
                    <td>{{data.preferito}}</td>
                    <td>{{data.rawal | number : '1.2-2'}}</td>
                    <!-- <td>{{data.week}}</td>
                    <td>{{data.vmin | number : '1.4-4'}}</td>
                    <td>{{data.vmax | number : '1.4-4'}}</td> -->
                </tr>

            </tbody>
        </table>
    </div>
</div>